export default '6.23.0';